<span class="field-view-value">{{displayText}}</span>
